"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shipment = exports.Setup = exports.SalesOrder = exports.RequestForQuote = exports.Product = exports.Production = exports.ProductImplementation = exports.Partner = exports.Inventory = exports.HumanResources = exports.FileManagement = exports.Common = void 0;
const Common = __importStar(require("./common"));
exports.Common = Common;
const FileManagement = __importStar(require("./file-management"));
exports.FileManagement = FileManagement;
const HumanResources = __importStar(require("./hr"));
exports.HumanResources = HumanResources;
const Inventory = __importStar(require("./inventory"));
exports.Inventory = Inventory;
const Partner = __importStar(require("./partners"));
exports.Partner = Partner;
const ProductImplementation = __importStar(require("./product-implementation"));
exports.ProductImplementation = ProductImplementation;
const Production = __importStar(require("./production"));
exports.Production = Production;
const Product = __importStar(require("./products"));
exports.Product = Product;
const RequestForQuote = __importStar(require("./request-for-quote"));
exports.RequestForQuote = RequestForQuote;
const SalesOrder = __importStar(require("./sales-order"));
exports.SalesOrder = SalesOrder;
const Setup = __importStar(require("./setup"));
exports.Setup = Setup;
const Shipment = __importStar(require("./shipment"));
exports.Shipment = Shipment;
//# sourceMappingURL=index.js.map